import * as ShopifyCart from '@shopify/theme-cart';

import { addMultipleItemsToCart } from '../../helper/request';

import { PRODUCT_TYPE, NEXT_STEP } from './const';

import { FREE_GIFT_PROPERTY } from '../FlyoutCart/store';

import { prepareInitialData } from './prepare_initial_data';

import { globalEventBus } from '@pixelcabin/ui-utils';

import {
  populateCartAttributes as populateRechargeCartAttributes,
  populateSubscriptionProperties as populateRechargeSubscriptionProperties
} from '../../helper/recharge';

import { populateCartAttributes as populateShopifySubscriptionCartAttributes } from '../../helper/shopify_subscriptions';

export const purchaseForm = 'purchaseForm';

export const mutations = {
  SELECT_VARIANT: 'SELECT_VARIANT',
  SET_FREE_GIFT: 'SET_FREE_GIFT',
  SET_PRODUCT_TYPE: 'SET_PRODUCT_TYPE',
  SET_QUANTITY: 'SET_QUANTITY',
  SET_UPSELL_QUANTITY: 'SET_UPSELL_QUANTITY',
  SET_SUBSCRIPTION_FREQUENCY: 'SET_SUBSCRIPTION_FREQUENCY',
  SET_SHOULD_SHOW_FREE_GIFT_DROPDOWN: 'SET_SHOULD_SHOW_FREE_GIFT_DROPDOWN',
  SET_HAS_NOT_ENOUGH_STOCK: 'SET_HAS_NOT_ENOUGH_STOCK',
  SELECT_SELLING_PLAN: 'SELECT_SELLING_PLAN'
};

export const actions = {
  addToCart: 'addToCart'
};

export const purchaseFormStore = () => {
  const initialData = prepareInitialData();

  return {
    namespaced: true,
    state: initialData,
    getters: {
      isSubscriptionBuilder(state) {
        return (
          state.selectedProductType === PRODUCT_TYPE.SUBSCRIBE &&
          state.subscribe.nextStep === NEXT_STEP.SUBSCRIPTION_BUILDER
        );
      },

      inventoryQuantity(state) {
        if (
          state.selectedVariant &&
          typeof state.selectedVariant.inventoryQuantity !== 'undefined'
        ) {
          return state.selectedVariant.inventoryQuantity;
        } else {
          return state.oneTime.inventoryQuantity;
        }
      },

      isOutOfStock(state, getters) {
        return getters.inventoryQuantity < 1;
      }
    },
    mutations: {
      [mutations.SELECT_VARIANT](state, variantId) {
        state.selectedVariant = state.variants.find(
          variant => variant.id === parseInt(variantId)
        );
      },

      [mutations.SET_FREE_GIFT](state, freeGift) {
        state.selectedFreeGift = freeGift;
      },

      [mutations.SET_QUANTITY](state, quantity) {
        state.quantity = quantity;
      },

      [mutations.SET_PRODUCT_TYPE](state, productType) {
        state.selectedProductType = productType;
      },

      [mutations.SET_UPSELL_QUANTITY](state, quantity) {
        state.selectedUpsellProductQuantity = quantity;
      },

      [mutations.SET_SUBSCRIPTION_FREQUENCY](state, frequency) {
        state.selectedSubscriptionFrequency = frequency;
      },

      [mutations.SET_SHOULD_SHOW_FREE_GIFT_DROPDOWN](
        state,
        shouldShowFreeGiftDropdown
      ) {
        state.shouldShowFreeGiftDropdown = shouldShowFreeGiftDropdown;
      },

      [mutations.SET_HAS_NOT_ENOUGH_STOCK](state, hasNotEnoughStock) {
        state.hasNotEnoughStock = hasNotEnoughStock;
      },

      [mutations.SELECT_SELLING_PLAN](state, sellingPlanId) {
        state.selectedSellingPlan = state.sellingPlans.find(
          sellingPlan => sellingPlan.id === parseInt(sellingPlanId)
        );
      }
    },
    actions: {
      [actions.addToCart]({ state, getters, commit }) {
        const { quantity } = state;

        const itemsToAddToCart = [];
        const options = {
          quantity,
          properties: {}
        };

        let variantId = state.oneTime.variantId;

        if (state.selectedVariant) {
          variantId = state.selectedVariant.id;
        }

        // If Subscription Builder, nothing added to cart: redirect
        // to builder page
        if (getters.isSubscriptionBuilder) {
          const cartAttributes = (() => {
            if (!__SHOPIFY_SUBSCRIPTIONS__) {
              return populateRechargeCartAttributes(
                state.handle,
                state.quantity,
                state.selectedSubscriptionFrequency,
                state.subscribe.shippingIntervalUnitType,
                state.context,
                state.selectedFreeGift,
                state.upSell,
                state.selectedUpsellProductQuantity
              );
            } else {
              const selectedSellingPlanId = state.selectedSellingPlan
                ? state.selectedSellingPlan.id
                : null;

              return populateShopifySubscriptionCartAttributes(
                state.handle,
                state.quantity,
                selectedSellingPlanId,
                state.context,
                state.selectedFreeGift,
                state.upSell,
                state.selectedUpsellProductQuantity
              );
            }
          })();

          return ShopifyCart.updateAttributes(cartAttributes).then(
            () => (window.location.href = state.subscribe.builderUrl)
          );
          // If item is a subscription item nonetheless, we need to
          // add the necessary line item properties for ReCharge
        } else if (
          state.selectedProductType === PRODUCT_TYPE.SUBSCRIBE &&
          state.subscribe.nextStep === NEXT_STEP.ADD_TO_CART &&
          !__SHOPIFY_SUBSCRIPTIONS__
        ) {
          variantId = state.selectedVariant.subscriptionVariantId;

          options.properties = {
            ...options.properties,
            ...populateRechargeSubscriptionProperties(
              state.selectedSubscriptionFrequency,
              state.subscribe.shippingIntervalUnitType
            )
          };
        }

        itemsToAddToCart.push({
          id: variantId,
          ...options,
          selling_plan:
            __SHOPIFY_SUBSCRIPTIONS__ &&
            state.selectedSellingPlan &&
            state.selectedProductType === PRODUCT_TYPE.SUBSCRIBE
              ? state.selectedSellingPlan.id
              : null
        });

        if (
          state.shouldShowFreeGiftDropdown &&
          state.selectedFreeGift &&
          state.selectedFreeGift.id
        ) {
          itemsToAddToCart.push({
            id: state.selectedFreeGift.id,
            quantity: 1,
            properties: {
              [FREE_GIFT_PROPERTY]: true
            }
          });
        }

        if (state.upSell && state.selectedUpsellProductQuantity) {
          itemsToAddToCart.push({
            id: state.upSell.id,
            quantity: state.selectedUpsellProductQuantity
          });
        }

        return addMultipleItemsToCart(itemsToAddToCart)
          .then(() => {
            globalEventBus.emit('flyoutCart.addItem');
          })
          .catch(error => {
            if (error.status === 422) {
              commit(mutations.SET_HAS_NOT_ENOUGH_STOCK, true);
            }

            console.error(error);
          });
      }
    }
  };
};
